import ApiService from '@/common/api.service';
import { saveAs } from 'file-saver';

const url = '/v1/exports';

const MatrixService = {
  create(ids, type = 'complexes') {
    const body = { file_name: 'matrix' };
    body[type] = ids;

    return ApiService.post(`${url}/matrix`, body, {
      responseType: 'arraybuffer'
    });
  },
  download(file, type, filename) {
    const date = new Date()
      .toLocaleString()
      .replace(new RegExp(/[\W\s/]/g), '');

    saveAs(new Blob([file], { type: type }), `${date}-${filename}`);
  },
  all(filters, type, params = { 'filter[type]': 'residence' }) {
    filters = Object.assign({}, filters);

    Object.keys(filters)
      .sort()
      .forEach(key => {
        params[key] = filters[key].value;
      });

    return ApiService.query(`${url}/matrix/${type}`, {
      params: params,
      responseType: 'arraybuffer'
    });
  }
};

export default MatrixService;
